import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { AuthShell, authInputClass, authButtonClass } from '../../components/auth/AuthShell';
import { postJson } from '../../lib/authFlows';

export default function ResetPasswordPage({ apiBase, loginPath, variant }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return setError('Şifre en az 6 karakter olmalı');
    if (pw !== pw2) return setError('Şifreler eşleşmiyor');
    setLoading(true);
    setError('');
    try {
      const d = await postJson(`${apiBase}/reset-password`, { token: params.get('token'), password: pw });
      toast.success(d.message);
      navigate(loginPath);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell variant={variant} loginPath={loginPath} testId="reset-password-page"
      title="Yeni şifre belirleyin" subtitle="En az 6 karakterli yeni şifrenizi yazın.">
      <form onSubmit={submit} className="space-y-4">
        <Input type="password" required value={pw} onChange={e => setPw(e.target.value)} placeholder="Yeni şifre"
          className={authInputClass(variant)} data-testid="reset-password-input" />
        <Input type="password" required value={pw2} onChange={e => setPw2(e.target.value)} placeholder="Yeni şifre (tekrar)"
          className={authInputClass(variant)} data-testid="reset-password-confirm-input" />
        {error && <p className="text-sm text-red-500" data-testid="reset-password-error">{error}</p>}
        <Button type="submit" disabled={loading} className={authButtonClass(variant)} data-testid="reset-password-submit-btn">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Şifremi Güncelle'}
        </Button>
      </form>
    </AuthShell>
  );
}
